module.exports = __webpack_public_path__ + "static/media/HeroFlow-01.36e5120a.svg";